<template>
  <v-container
    bg
    fill-height
    align="center"
    grid-list-md
    text-xs-center
    v-on:keyup.13="validateVoucher"
  >
    <v-layout align-center justify-center style="margin: 0px">
      <v-flex class="middle" xs12 sm8 md4>
        <v-layout class="mb-3 validateCard">
          <img src="../assets/cropped-pak.png" alt="background" />
        </v-layout>
        <v-card class="elevation-12 validateCard">
          <v-toolbar dark class="toolbar">
            <v-toolbar-title>Внесете код на локацијата</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="locationCode"
                prepend-icon="place"
                name="locationCode"
                label="Код на локација"
                id="locationCode"
                type="number"
                @keydown.enter.prevent
              ></v-text-field>
            </v-form>
          </v-card-text>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dark
              color="darkgreen"
              class="btnLogin"
              @click="validateVoucher"
              >Валидирај код</v-btn
            >
          </v-card-actions> -->
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            dark
            color="darkgreen"
            class="btnLogin1"
            @click="validateVoucher"
            >Валидирај код</v-btn
          >
        </v-card-actions>
        <v-toast v-if="toast" :timeout="20000" class="toast-error">
          {{ errorMessage }}
        </v-toast>
      </v-flex>
    </v-layout>
    <div class="custom-modal" v-if="dialog">
      <div v-if="!redirect" class="modal-content">
        <h2 class="modal-title">Потврда</h2>
        <h5>
          Дали сакате да го поништите ваучерот со вредност од
          {{ this.value }} денари?
        </h5>
        <div class="modal-actions">
          <button class="btn modal-btn" @click="confirmUseVoucher">
            Поништи
          </button>
          <button
            class="btn modal-btn"
            style="background-color: #6C757D !important;"
            @click="cancelUseVoucher"
          >
            Откажи
          </button>
        </div>
      </div>
      <div v-if="redirect" class="modal-content linear-loader">
        <v-col class="text-subtitle-1 text-center" cols="12">
          Ве молиме почекајте
        </v-col>
        <v-col cols="12"
          ><v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="8"
          ></v-progress-linear
        ></v-col>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Successvouchercheck from "@/views/Successvouchercheck.vue";
import store from "./../store/index";

export default {
  name: "Vouchercheck",
  props: {
    voucherCode: {
      type: String,
      required: true,
    },
  },
  components: {
    Successvouchercheck,
  },
  data() {
    return {
      locationCode: "",
      dialog: false,
      validationResponse: "",
      redirect: false,
      counter: null,
      value: null,
      toast: false,
      errorMessage: "",
      extension_url: "",

    };
  },
  mounted(){
    this.setURL();
  },
  computed: {
    ...mapGetters(["validationStatus"]),
  },
  methods: {
    setURL() {
      if (store.state.ENV === "dev") {
        this.extension_url = store.state.EXTENSION_DEV_URL;
      } else if (store.state.ENV === "test") {
        this.extension_url = store.state.EXTENSION_TEST_URL;
      } else {
        this.extension_url = store.state.EXTENSION_PROD_URL;
      }
    },
    async validateVoucher() {
      try {
              console.log("Extension url is:", this.extension_url);

        const postData = {
          locationCode: this.locationCode,
          voucherCode: this.voucherCode,
        };

        const response = await axios.post(
          `${this.extension_url}api/Voucher/PostVoucherValidationCheck`,
          postData
        );
        if (response.status === 200) {
          this.value = response.data.voucherType.value;
          this.dialog = true;
          this.validationResponse = "";
        }
      } catch (error) {
        console.log(error.response);
        if (error.response.data == "This location code doesn't exists") {
          this.errorMessage = "Невалиден код на локација";
          this.toast = true;
        }
        if (error.response.data == "This location is not active") {
          this.errorMessage = "Локацијата не е активна";
          this.toast = true;
        }
        if (error.response.data == "No voucher or location provided") {
          this.errorMessage = "Нема пратено ваучер или локација";
          this.toast = true;
        }
        if (error.response.data == "Voucher is not active") {
          this.errorMessage = "Ваучерот не е активен";
          this.toast = true;
        }
        if (error.response.data == "Voucher is already used") {
          this.errorMessage = "Ваучерот е веќе искористен";
          this.toast = true;
        }
        if (
          error.response.data ==
          "Wrong service provider for location for voucher"
        ) {
          this.errorMessage = "Грешен код за локација за провајдер";
          this.toast = true;
        }
        if (error.response.data == "Voucher doesn't exist") {
          this.errorMessage = "Ваучерот не постои";
          this.toast = true;
        }
        setTimeout(() => {
          this.toast = false;
          this.errorMessage = "";
        }, 20000);
      }
    },
    async confirmUseVoucher() {
      await this.useVoucher().then(() => {
        this.redirect = true;
        this.startCountdown();
      });
    },
    cancelUseVoucher() {
      this.locationCode = ""; // Reset
      this.dialog = false;
    },
    async useVoucher() {
      try {
        const response = await axios.put(
          `${this.extension_url}api/Voucher/ExecuteVoucher`,
          {
            locationCode: this.locationCode,
            voucherCode: this.voucherCode,
          }
        );
        if (response.status === 200) {
          console.log("Voucher successfully used");

          this.locationCode = ""; // Reset
        } else {
          console.log(response.data);
        }
      } catch (error) {
        if (error.response.data == "Voucher or Location is not valid") {
          this.errorMessage =
            "Кодот на ваучерот или кодот на локацијата не е валиден";
          this.toast = true;
        }
        if (
          error.response.data ==
          "Wrong service provider for location for voucher"
        ) {
          this.errorMessage = "Грешен код за локација за провајдер";
          this.toast = true;
        }
        if (error.response.data == "Voucher is not bought") {
          this.errorMessage = "Ваучерот не е доделен на провајдерот";
          this.toast = true;
        }
        setTimeout(() => {
          this.toast = false;
          this.errorMessage = "";
        }, 20000);
      }
    },
    startCountdown() {
      this.counter = 5;
      const countdownInterval = setInterval(() => {
        this.counter--;
        if (this.counter === 0) {
          clearInterval(countdownInterval);
          this.redirect = true;
          setTimeout(() => {
            this.$router.push({
              path: "/Successvouchercheck",
            });
          }, 1000);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.v-progress-linear .v-progress-linear__indeterminate .long,
.v-progress-linear .v-progress-linear__indeterminate .short {
  background-color: rgb(18, 112, 92) !important;
}
@media screen and (max-width: 767px) {
  .v-progress-linear {
    // margin-bottom: 60px !important;
    margin-top: -20px !important;
  }
}
.v-progress-linear {
  margin-top: -30px;
}

@media screen and (max-width: 767px) {
  .text-subtitle-1 {
    margin-top: 40px !important;
    font-size: 20px !important;
  }
}
.text-subtitle-1 {
  margin-top: 80px;
  font-size: 22px;
}
.linear-loader {
  height: 15%;
  border: 2px solid rgb(18, 112, 92);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -30px;
}
.toast-error {
  background-color: #ff6347;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  max-width: 90%;
  margin: 0 auto;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}
.validateCard {
  margin-left: 10px !important;
  margin-right: 10px;
}
@media screen and (max-width: 767px) {
  .toast-error {
    text-align: center;
    width: 65% !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    margin-bottom: 150px !important;
  }
}
</style>
